/**
 * Фича-флаги фронтенда.
 *
 * GOOGLE_AUTH_ENABLED — вход/привязка через Google. Отключено по закону РФ,
 * запрещающему авторизацию через иностранные сервисы. Код компонентов и роутов
 * сохранён: чтобы вернуть, достаточно VUE_APP_GOOGLE_AUTH_ENABLED=true и пересборки
 * (плюс GOOGLE_AUTH_ENABLED=True на бэкенде — без него эндпоинты не зарегистрированы).
 */
export const GOOGLE_AUTH_ENABLED = process.env.VUE_APP_GOOGLE_AUTH_ENABLED === 'true';

/**
 * PORTFOLIOS_STAFF_ONLY — раздел «Портфели» (/portfolios) и переключатель «Показывать мой портфель
 * в рейтинге» в Портфеле видны только Moderators/Editors, пока раздел на согласовании.
 * Открыть всем подписчикам: false здесь и PORTFOLIOS_STAFF_ONLY = False в portfolios/constants.py.
 */
export const PORTFOLIOS_STAFF_ONLY = true;
